var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-skeleton"},[_c('b-skeleton-table',{attrs:{"rows":_vm.rows,"columns":_vm.columns.length,"table-props":{ striped: true, responsive: true },"animated":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }